/**
 * JSON 解析防精度丢失。
 * 服务端雪花ID为19位长整型,超过 JS Number 安全整数(2^53),直接 JSON.parse
 * 末尾位会被截断(如 ...1893 → ...2000),导致 recvId 错乱、好友校验失败。
 * 解析前将 16 位以上整数(仅雪花ID;时间戳13位/自增ID不受影响)转为字符串,
 * 前后端传参 Jackson 支持字符串→Long 强转,等值比较两侧类型自洽(同为字符串)。
 */
export function safeParseJson(text) {
	if (typeof text !== 'string' || !text) {
		return text;
	}
	try {
		return JSON.parse(text.replace(/([:\[,])(-?\d{16,})(?=[,\]\}])/g, '$1"$2"'));
	} catch (e) {
		try {
			return JSON.parse(text);
		} catch (e2) {
			return text;
		}
	}
}

export default safeParseJson;
